import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Body } from "@ddm-design-system/typography";
import { Link } from "react-router-dom";
import useContent from "../../../hooks/useContent";
import AnchorContainer from "../../common/anchor_container/AnchorContainer";
import { getComponentLines } from "../../../store/components/actions";
import { getCurrentComponentLines, getIsLoadingLines } from "../../../store/components/selectors";
import { ILine } from "../../../store/outlets/types";
import Routes from "../../../routes";

interface IProps {
  componentId: string;
  outletId: string;
}

const Lines: React.FC<IProps> = ({ componentId, outletId }) => {
  const dispatch = useDispatch();
  const { outletDetails: content, common } = useContent();
  const lines = useSelector(getCurrentComponentLines());
  const loading = useSelector(getIsLoadingLines);

  useEffect(() => {
    dispatch(getComponentLines(componentId));
  }, [dispatch, componentId]);

  const list = useMemo(() => {
    if (!lines) {
      return [];
    }

    let counterLines = 0;

    return (
      lines
        ?.filter(
          l => l.type === "COMPRESSOR" || l.components.some(c => c.type !== "PressureChamber")
        )
        .map((l: ILine) => {
          const mainComponent = l.components.find(c => c.type !== "PressureChamber");

          return {
            title: `${l.type?.toLocaleLowerCase()} line ${
              mainComponent?.position || ++counterLines
            }`,
            href: l.type + l.id,
            renderContent: () => (
              <div className="flex flex-row flex-wrap">
                {l.components
                  .filter(c => c.type === "PressureChamber")
                  .sort((a, b) => a.position - b.position)
                  .map((c: ILine["components"][0]) => (
                    <Link
                      to={Routes.outletComponentDetails
                        .replace(":id", outletId)
                        .replace(":cid", c.id)}
                      className="py-xs px-sm mr-md mb-md rounded border border-grey-grey100"
                      key={c.type + c.position}
                    >
                      {common[`common_${c.type[0].toLocaleLowerCase()}${c.type.slice(1)}`]}{" "}
                      {c.position}
                    </Link>
                  ))}
                {!l.components.length && (
                  <Body className="text-grey-grey100">{content.outlet_component_no_lines}</Body>
                )}
              </div>
            )
          };
        }) || []
    );
  }, [lines, content]);

  return (
    <div>
      <AnchorContainer
        list={list}
        emptyString={content.outlet_component_no_lines}
        loading={loading}
      />
    </div>
  );
};

export default Lines;
